import { render, staticRenderFns } from "./PxCompraPagamentoErrorTag.vue?vue&type=template&id=6f4b4dfc"
import script from "./PxCompraPagamentoErrorTag.vue?vue&type=script&lang=js"
export * from "./PxCompraPagamentoErrorTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports